"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClusterMarkerLayer = void 0;
// import 'leaflet.markercluster';
const react_1 = __importDefault(require("react"));
const uuid_1 = require("uuid");
const Marker_1 = require("./Marker");
const MarkerLayer_1 = require("./MarkerLayer");
const ObjectInMap_1 = require("./ObjectInMap");
class Cluster {
    constructor(map, radiusInPixels, useAverageLocation, startZoom, endZoom, objects, clustersData, reactElement, parentCluster) {
        this.clusters = [];
        this.marker = undefined;
        this.markerLayer = undefined;
        this.isActive = false;
        this.isInnerInitialized = false;
        this.useAverageLocation = true;
        this.id = (0, uuid_1.v4)();
        this.map = map;
        this.radius = radiusInPixels;
        this.useAverageLocation = useAverageLocation;
        this.startZoom = startZoom;
        this.endZoom = endZoom;
        this.objects = objects;
        this.parentCluster = parentCluster;
        this.reactElement = reactElement;
        this.clusters = clustersData.map((data) => createCluster(data, map, radiusInPixels, useAverageLocation, reactElement, this));
        this.allSubObjectsCount =
            objects.length +
                this.clusters.reduce((acc, cluster) => acc + cluster.allSubObjectsCount, 0);
    }
    initialize() {
        this.markerLayer = new MarkerLayer_1.MarkerLayer(this.map, {
            useAverageLocation: this.useAverageLocation
        });
        this.marker = new Marker_1.Marker(0, 0, (marker, map) => {
            const onClick = () => {
                map.flyTo(marker.getLocation(), this.endZoom + 1);
            };
            return (react_1.default.createElement("div", { onClick: onClick }, this.reactElement(this.allSubObjectsCount)));
        }, this.map);
        this.marker.setActive(false);
        this.markerLayer.add(this.objects);
        this.parentCluster?.markerLayer.add(this.marker);
        const onLocationChange = () => {
            this.marker.setLocation(this.markerLayer.getLocation());
        };
        this.markerLayer.addListener("locationchange", onLocationChange);
        this.marker.setLocation(this.markerLayer.getLocation());
        this._onRelase = () => {
            this.markerLayer.removeListener("locationchange", onLocationChange);
            this.marker.delete();
        };
        this.clusters.forEach((cluster) => {
            cluster.initialize();
        });
        this.isInnerInitialized = true;
    }
    initializeObjects() {
        this.marker.initialize();
        this.markerLayer.initialize();
        this.clusters.forEach((cluster) => {
            cluster.initializeObjects();
        });
    }
    redisplay(force = false) {
        this._display(this.map.getZoom(), force);
    }
    _display(zoom, force) {
        if (!this.isInnerInitialized)
            return;
        if (zoom >= this.startZoom &&
            zoom <= this.endZoom &&
            this.clusters.length > 0 &&
            this.isActive) {
            this.marker?.setActive(true);
            this.marker?.initialize();
        }
        else {
            this.marker?.delete();
        }
        if (zoom >= this.startZoom && this.isActive) {
            this.objects.forEach((o) => {
                this.markerLayer.add(o);
                o.setActive(true);
                o.initialize();
            });
        }
        else {
            this.objects.forEach((o) => {
                o.delete();
            });
        }
    }
    getAllSubclusters() {
        return this.clusters.reduce((acc, cluster) => {
            return [...acc, ...cluster.getAllSubclusters()];
        }, this.clusters);
    }
    // Use for clean up before deleting
    release() {
        this.clusters.forEach((cluster) => {
            cluster.release();
        });
        this._onRelase?.();
    }
    setActive(isActive, force = false) {
        this.clusters.forEach((cluster) => {
            cluster.setActive(isActive);
        });
        if (this.isActive === isActive && !force)
            return;
        this.isActive = isActive;
        this.redisplay(true);
    }
    getTotalSubclustersCount() {
        let count = 0;
        this.clusters.forEach((cluster) => {
            count += cluster.getTotalSubclustersCount();
        });
        return count + this.clusters.length;
    }
    log() {
        const data = {
            id: this.id,
            zoom: [this.startZoom, this.endZoom]
        };
        return this.clusters.length > 0
            ? {
                ...data,
                clusters: this.clusters.map((cluster) => cluster.log()),
                subclustersCount: this.getTotalSubclustersCount()
            }
            : {
                ...data,
                objects: this.objects.map((object) => object.id)
            };
    }
}
function createCluster(data, map, radiusInPixels, useAverageLocation, reactElement, parentCluster) {
    const cluster = new Cluster(map, radiusInPixels, useAverageLocation, data.startZoom, data.endZoom, data.objects, data.clusters, reactElement, parentCluster);
    return cluster;
}
const defaultClusterMarkerLayerProps = {
    radius: 200,
    useAverageLocation: true
};
class ClusterMarkerLayer extends ObjectInMap_1.ObjectInMap {
    constructor(reactElement, map, options) {
        super(map, "ClusterLayer", options);
        this.mainClusters = [];
        this.clustersByZoom = {};
        this.objects = [];
        this._onZoomEnd = this._onZoomChange.bind(this);
        this._lastZoom = -1;
        const props = {
            ...defaultClusterMarkerLayerProps,
            ...options
        };
        this.clusterReactElement = reactElement;
        this.radius = props.radius;
        // This marker fix the bug. If all submarker is not active, this is. The layer stays active
        const justMarker = new Marker_1.Marker(30, 30, () => {
            return react_1.default.createElement(react_1.default.Fragment, null);
        }, map);
        super.add(justMarker);
        map.on("zoomend", this._onZoomEnd);
    }
    _onZoomChange() {
        const currentZoom = this.map.getZoom();
        const willBeActive = this.clustersByZoom[currentZoom];
        willBeActive?.forEach((cluster) => {
            cluster.redisplay();
        });
        if (this._lastZoom >= 0 && this._lastZoom !== currentZoom) {
            const wasActive = this.clustersByZoom[this._lastZoom];
            const filteredWasActive = wasActive?.filter((cluster) => willBeActive.indexOf(cluster) < 0);
            filteredWasActive?.forEach((cluster) => {
                cluster.redisplay();
            });
        }
        this._lastZoom = currentZoom;
    }
    add(marker) {
        super.add(marker);
        if (Array.isArray(marker)) {
            this.objects.push(...marker);
        }
        else {
            this.objects.push(marker);
        }
        this._set(this.objects);
    }
    _set(markers) {
        markers.forEach((marker) => {
            marker.setActive(false);
        });
        const clusters = this._splitToClusters(markers);
        this.mainClusters.forEach((cluster) => {
            cluster.release();
        });
        this.mainClusters = clusters.map((data) => createCluster(data, this.map, this.radius, this.useAverageLocation, this.clusterReactElement));
        this.mainClusters.forEach((cluster) => {
            const allSubclusters = [cluster, ...cluster.getAllSubclusters()]; // Including itself
            allSubclusters.forEach((subcluster) => {
                for (let zoom = subcluster.startZoom; zoom <= subcluster.endZoom; zoom++) {
                    if (!this.clustersByZoom[zoom])
                        this.clustersByZoom[zoom] = [];
                    this.clustersByZoom[zoom].push(subcluster);
                }
            });
        });
        this.mainClusters.forEach((cluster) => {
            cluster.setActive(this.isActive);
            cluster.initialize();
        });
        this.mainClusters.forEach((cluster) => {
            super.add(cluster.markerLayer);
        });
    }
    //#region SPLIT_TO_CLUSTERS functions
    _splitToClusters(markers) {
        const mainGroupsDict = [];
        const mainGroups = [];
        const min = this.map.getMinZoom();
        const max = this.map.getMaxZoom();
        markers.forEach((marker) => {
            let lastGroup;
            const location = marker.getLocation();
            for (let i = min; i <= max; i++) {
                const [x, y] = this._getClusterIndexes(location, i);
                const parentGroups = lastGroup
                    ? lastGroup.groupsDict
                    : mainGroupsDict;
                if (!parentGroups[x])
                    parentGroups[x] = {};
                if (!parentGroups[x][y])
                    parentGroups[x][y] = {
                        x,
                        y,
                        zoom: i,
                        objects: [],
                        groupsDict: {},
                        groups: []
                    };
                const currentGroup = parentGroups[x][y];
                if (lastGroup && lastGroup.groups.indexOf(currentGroup) < 0)
                    lastGroup.groups.push(currentGroup);
                if (!lastGroup && mainGroups.indexOf(currentGroup) < 0)
                    mainGroups.push(currentGroup);
                if (i === max)
                    currentGroup.objects.push(marker);
                lastGroup = currentGroup;
            }
        });
        const result = mainGroups.map((group) => {
            return this._simplifyGroup(group);
        });
        return result;
    }
    _simplifyGroup(group) {
        const cluster = {
            startZoom: group.zoom,
            endZoom: group.zoom,
            clusters: [],
            objects: group.objects
        };
        const clusters = group.groups.map((group) => {
            return this._simplifyGroup(group);
        });
        if (clusters.length === 1) {
            cluster.endZoom = clusters[0].endZoom;
            cluster.clusters = clusters[0].clusters;
            cluster.objects = [...cluster.objects, ...clusters[0].objects];
        }
        if (clusters.length > 1)
            cluster.clusters = clusters;
        return cluster;
    }
    _getClusterIndexes(objectLocation, zoom) {
        const point = this.map.project(objectLocation, zoom);
        const clusterXIndex = Math.floor(point.x / this.radius);
        const clusterYIndex = Math.floor(point.y / this.radius);
        return [clusterXIndex, clusterYIndex];
    }
    //#endregion
    setActive(isActive, force) {
        super.setActive(isActive, force, true);
        this.mainClusters.forEach((cluster) => {
            cluster.setActive(isActive, true);
        });
    }
    initialize() {
        const r = super.initialize();
        this.mainClusters.forEach((cluster) => {
            cluster.initializeObjects();
        });
        this._onZoomEnd();
        return this;
    }
    delete() {
        super.delete();
        this.mainClusters.forEach((cluster) => {
            cluster.release();
        });
        this.map.off("zoomend", this._onZoomEnd);
    }
}
exports.ClusterMarkerLayer = ClusterMarkerLayer;
